module.exports = __webpack_public_path__ + "img/card-discover.8c82d0ba.svg";